export const authEnum = {
  authToken: "authToken",
};

export const API = {
  auth: "/dummyData/authToken.json",
  centerlist: "/dummyData/centerlist.json",
  repairInfoData: "/dummyData/repairInfoData.json",
};
